import { Checkbox } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { memo, useContext } from "react";
import { DashboardsTableContext } from "../../../../../contexts/TablesContext/DashboardsTableProvider";

const useStyles = makeStyles((theme) => ({
    checkBox: {
        padding: 'unset !important',
        marginRight: '4px !important',
        "& > svg": {
            width: '20px !important',
            height: '20px !important',
        }
    },
}));

const SelectionColumn: React.FC<{}> = () => {
    const { filters, setFilters } = useContext(DashboardsTableContext);
    const classes = useStyles();

    return (<>
        <Checkbox edge="end"
            className={classes.checkBox}
            checked={filters.added?.some(added => added === '+Infinity')}
            onClick={() => setFilters({ added: !filters.added?.some(added => added === '+Infinity') ? ['+Infinity'] : [] })}
            disableRipple />
    </>);
}

export default memo(SelectionColumn);
